import type { DeepPartial } from '@luna/utils-ts';

import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: DeepPartial<ContactDataManagementFeatureConfig> = {
    address: {
        countrySelect: true,
        poBoxType: true,
        streetNumberField: true,
        additionalFields: true,
        streetTypeSelect: true,
    },
    changeNotEditableContactMessengerTopicId: '13',
    proofOfAddressExternalApplication: true,
};
